// extracted by mini-css-extract-plugin
export var radioInputRow = "J_v0";
export var radioInputColumn = "J_v1";
export var inputOptionRow = "J_sn";
export var inputOptionColumn = "J_sp";